// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rIVt","top":"styles_top__3V6QJ"};